import {useState, useCallback} from 'react'

import {internalProps} from '../../../types/BS_types'

type AuthAgentDialogParams = {
  onOpen?: () => unknown
}
type AuthAgentDialog = {
  onClose: () => void
  show: (() => void) | undefined
  visible: boolean
}
export function useAuthAgentDialog({onOpen}: AuthAgentDialogParams = {}): AuthAgentDialog {
  const [visible, setShow] = useState(false)
  const onClose = useCallback(() => {
    setShow(false)
  }, [setShow])
  const show = useCallback(() => {
    setShow(true)

    if (onOpen != null) {
      onOpen()
    }
  }, [setShow, onOpen])
  return {
    show: internalProps['teamcity.ui.showAuthAgentDialog'] === true ? show : undefined,
    visible,
    onClose,
  }
}
